import { FichaService } from './../../../ficha-veiculo.service';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { FichaCadastro } from '../../ficha-cadastro';
import { VeiculoEmSeuNome } from '../../model/veiculo';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-ficha-cadastro-veiculo-proprio',
  templateUrl: './ficha-cadastro-veiculo-proprio.component.html',
  styleUrls: ['./ficha-cadastro-veiculo-proprio.component.scss'],
})
export class FichaCadastroVeiculoProprioComponent implements OnInit {
  @ViewChild('naoPossuiCaminhaoEmSeuNome', { static: true })
  naoPossuiCaminhaoEmSeuNome: any;
  @ViewChild('simPossuiCaminhaoEmSeuNome', { static: true })
  simPossuiCaminhaoEmSeuNome: any;

  @Input() fichaCadastro: FichaCadastro;

  veiculos: VeiculoEmSeuNome[] = [{}];

  form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private fichaService: FichaService
  ) {}

  ngOnInit() {
    this.buildForm();
    this.recuperaPayload();
  }

  private recuperaPayload(): void {
    const payload = this.fichaCadastro.getPayload();
    if (payload && payload.qtdeVeiculoProprio) {
      this.simPossuiCaminhaoEmSeuNome.value = false;
      this.naoPossuiCaminhaoEmSeuNome.value = true;
      this.form.get('possuiCaminhaoEmSeuNome').setValue(false);
      this.form.get('quantidadeCaminhao').setValue(payload.qtdeVeiculoProprio);

      if (payload.veiculoProprioTemp) {
        this.veiculos = payload.veiculoProprioTemp;
      }
      return;
    }
    this.simPossuiCaminhaoEmSeuNome.value = false;
    this.naoPossuiCaminhaoEmSeuNome.value = true;
    this.form.get('possuiCaminhaoEmSeuNome').setValue(false);
  }

  private buildForm(): void {
    this.form = this.formBuilder.group({
      possuiCaminhaoEmSeuNome: [null],
      quantidadeCaminhao: [null, [this.quantidadeValidator()]],
    });
  }

  private quantidadeValidator(): ValidatorFn {
    return (control: AbstractControl): Validators | null => {
      if (!this.form) return null;
      const { possuiCaminhaoEmSeuNome } = this.form.value;
      if (possuiCaminhaoEmSeuNome) return null;
      const value = control.value;
      if (value < this.veiculos.filter((v) => v.saved).length) {
        return { required: true };
      }

      return null;
    };
  }

  public get possuiCaminhaoEmSeuNome(): boolean {
    return this.form.get('possuiCaminhaoEmSeuNome').value;
  }

  public get quantidadeCaminhao(): number {
    return Number(this.form.get('quantidadeCaminhao').value);
  }

  setPossuiCaminhaoEmSeuNome(event) {
    const component = <HTMLInputElement>event.target;

    if (component.id === 'naoPossuiCaminhaoEmSeuNome') {
      this.simPossuiCaminhaoEmSeuNome.value = !component.checked;
      this.form.get('possuiCaminhaoEmSeuNome').setValue(!component.checked);
      return;
    }

    this.naoPossuiCaminhaoEmSeuNome.value = !component.checked;
    this.form.get('possuiCaminhaoEmSeuNome').setValue(component.checked);
  }

  public changeFormVeiculoLista(): void {}
  public changeFormValidList(): void {}

  public get isNextAvailable(): boolean {
    const { possuiCaminhaoEmSeuNome, quantidadeCaminhao } = this.form.value;
    if (!possuiCaminhaoEmSeuNome) {
      return this.form.valid && quantidadeCaminhao && this.hasAllVeiculoSave;
    }
    return !!possuiCaminhaoEmSeuNome;
  }

  public get hasAllVeiculoSave(): boolean {
    return (
      this.veiculos &&
      this.veiculos.length &&
      this.veiculos.every((v) => v.saved && !v.isEdit)
    );
  }

  private mapVeiculo(veiculo: VeiculoEmSeuNome): any {
    const {
      isNaoSeiPlaca,
      veiculoPlaca,
      veiculoCategoria,
      veiculoMarca,
      veiculoAno,
      veiculoModelo,
      veiculoVersao,
    } = veiculo;

    if (!isNaoSeiPlaca) {
      return {
        placa: veiculoPlaca,
      };
    }

    return {
      anoModelo: veiculoAno,
      categoria: { id: veiculoCategoria },
      marca: { id: veiculoMarca.id },
      modelo: { id: veiculoModelo.id },
      versao: { id: veiculoVersao.id },
    };
  }

  public onClickPrevious() {
    this.fichaCadastro.onClickPrevious();
  }

  public saveVeiculo(): void {
    const { quantidadeCaminhao } = this.form.value;
    this.fichaCadastro.setPayload(
      'qtdeVeiculoProprio',
      Number(quantidadeCaminhao)
    );
    this.fichaCadastro.setPayload('veiculoProprioTemp', this.veiculos);
  }

  public onClickNext() {
    const { possuiCaminhaoEmSeuNome, quantidadeCaminhao } = this.form.value;

    this.fichaCadastro.setPayload(
      'qtdeVeiculoProprio',
      !possuiCaminhaoEmSeuNome ? Number(quantidadeCaminhao) : 0
    );

    this.fichaCadastro.setPayload(
      'primeiroVeiculo',
      possuiCaminhaoEmSeuNome ? true : false
    );

    if (!possuiCaminhaoEmSeuNome) {
      this.fichaCadastro.setPayload(
        'veiculoProprio',
        this.veiculos.map(this.mapVeiculo)
      );
      this.fichaCadastro.setPayload('veiculoProprioTemp', this.veiculos);
    }

    this.fichaCadastro.onClickNext();
    this.putDataClient();
  }

  private putDataClient() {
    this.fichaService
      .putRecoverFullDataProposal(this.fichaCadastro.recoverData)
      .pipe(take(1))
      .subscribe();
  }
}
